// extracted by mini-css-extract-plugin
export var profileBox = "sidebar-module--profileBox--c384d";
export var profileBox__bg = "sidebar-module--profileBox__bg--83fbc";
export var profileBox__icon = "sidebar-module--profileBox__icon--a704a";
export var profileBox__iconImg = "sidebar-module--profileBox__iconImg--901aa";